import React, { useState } from 'react'
import UserPropertiesModal from 'components/PropertyModalSelector'
import { useLookupContext } from 'contexts/LookupContext'
import { useTextualContext } from 'contexts/TextualContext'
import { useMsal } from '@azure/msal-react'

const MyProperties = () => {
	const [modalOpen, setModalOpen] = useState(true)
	const { users } = useLookupContext()
	const { t } = useTextualContext()
	const { instance } = useMsal()
	const idToken = sessionStorage.getItem('idToken')

	const estates = users.map((user) => ({
		streetAddress: user.streetAddress,
		estateId: user.estateId,
		uniqueUserId: user.uniqueUserId,
		divisionMpcCd: user.divisionMpcCd,
		marketingMpcCd: user.marketingMpcCd,
		communityMpcCd: user.communityMpcCd,
		model: user.model,
		elevation: user.elevation,
		consent: user.consent,
		finalExpiryReminderEmail: user.finalExpiryReminderEmail,
	}))

	const allEstatesExpired =
		estates &&
		estates.length > 0 &&
		estates.every(
			(estate) =>
				estate.finalExpiryReminderEmail &&
				new Date(estate.finalExpiryReminderEmail.replace(' ', 'T')) < new Date()
		)

	if (!users || users.length === 0 || allEstatesExpired) {
		setTimeout(() => {
			sessionStorage.clear()
			instance.logoutRedirect({
				idTokenHint: idToken,
				onRedirectNavigate: () => {
					return true
				},
			})
		}, 3000)
	}

	const heading = t('multiple-home.heading')

	return (
		<UserPropertiesModal
			open={modalOpen}
			onClose={() => setModalOpen(false)}
			title={heading}
			estates={estates}
			showCloseButton={false}
		/>
	)
}

export default MyProperties
